<template>
  <div
    class="runTimeStatisticsWrap mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="runTimeStaContent">
      <div class="listWrap">
        <TabsCom :tabList="systemList" @getTabsActive="getTabsActive" />
      </div>
      <div class="statisticsWrap">
        <div class="leftTree commonWrap">
          <RegionTreeCom @getActiveTree="getActiveTree" />
        </div>
        <div class="rightData">
          <div class="tabABar">
            <div class="tableBox commonWrap">
              <div style="width: 95%; height: 90%; margin: 20px auto 10px">
                <OriginalTable :tableList="tableList" :tableHead="tableHead" />
              </div>
            </div>
            <div class="barBox commonWrap">
              <div class="commonTitle">
                <h4><span>1</span>运行时间</h4>
                <div style="margin-right: 20px">
                  <el-radio-group
                    v-model="runTimeActive"
                    size="mini"
                    @change="getBarData"
                  >
                    <el-radio-button label="month">月</el-radio-button>
                    <el-radio-button label="year">年</el-radio-button>
                    <el-radio-button label="total">总累计</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div class="commonContentBox">
                <PublicEcharts
                  :id="'transverse'"
                  :chartsData="barList"
                  :type="'themeTransverseBar'"
                />
              </div>
            </div>
          </div>
          <div class="lineBox commonWrap">
            <div class="commonTitle">
              <h4></h4>
              <el-radio-group
                v-model="showTime"
                size="mini"
                style="margin-right: 20px"
                @change="getChartsData"
              >
                <el-radio-button label="month">月</el-radio-button>
                <el-radio-button label="year">年</el-radio-button>
              </el-radio-group>
            </div>
            <div class="commonContentBox">
              <PublicEcharts
                :id="'myCharts'"
                :chartsData="chartsData"
                :type="'lightLine'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegionTreeCom from "@/components/nengyuanguanli/RegionTreeCom";
import PublicEcharts from "@/components/PublicEcharts.vue";
import { dateFtt } from "@/assets/js/utils";
import OriginalTable from "@/components/table/OriginalTable.vue";
import TabsCom from "@/components/nengyuanguanli/TabsCom.vue";
import api from "@/api";
export default {
  components: {
    RegionTreeCom,
    PublicEcharts,
    OriginalTable,
    TabsCom,
  },
  data() {
    return {
      systemList: [],
      activeSystem: 0,
      runTimeActive: "month",
      barList: {
        name: "运行时间",
        unit: "天",
        xData: [],
        yData: [],
      },
      tableHead: [
        { label: "名称", prop: "name" },
        { label: "今日累计/h", prop: "day" },
        { label: "本月累计/天", prop: "month" },
        { label: "年度累计/天", prop: "year" },
        { label: "总累计/天", prop: "total" },
      ],
      tableList: [],
      showTime: "month",
      chartsData: { title: "运行时长", unit: "", xData: [], dataArr: [] },
      treeId: "",
    };
  },
  methods: {
    getTabsActive(val) {
      this.activeSystem = val.index;
    },
    async getSystemList() {
      let res = await api.energyRunningTime({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        pageName: "RunTimeStatistics",
        key: "runtimeSystems",
      });
      if (res && res.status == 200) {
        this.systemList = res.data;
        this.getActiveTree({ treeActive: this.treeId });
      }
    },
    getActiveTree(data) {
      this.treeId = data.treeActive;
      if (this.systemList.length == 0) return;
      this.getChartsData();
      this.getTabList();
    },
    async getChartsData() {
      this.$store.commit("SET_LOADING", true);
      let res = await api.energyRunningChartsData({
        assetId: this.treeId,
        label: "区域位置",
        subItemId: this.systemList[this.activeSystem].id,
        timeType: this.showTime,
      });
      this.chartsData.xData = [];
      this.chartsData.dataArr = [];
      this.chartsData.unit = this.showTime == "month" ? "小时" : "天";
      // console.log(res);
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        let arr = [];
        res.data.data.map((v) => {
          this.chartsData.xData.push(
            this.showTime == "month"
              ? dateFtt("yyyy-MM-dd", new Date(v.ts))
              : dateFtt("yyyy-MM", new Date(v.ts))
          );
          arr.push(v.chartParamsList);
        });
        for (let i = 0; i < arr[0].length; i++) {
          this.chartsData.dataArr.push({ name: "", data: [] });
          arr.forEach((item) => {
            this.chartsData.dataArr[i].name = item[i].name;
            this.chartsData.dataArr[i].data.push(
              (item[i].value / (this.showTime == "month" ? 60 : 1440)).toFixed(
                2
              )
            );
          });
        }
      } else {
        this.$store.commit("SET_LOADING", false);
        this.$message.error(res.data.data);
      }
    },
    async getTabList() {
      this.tableList = [];
      this.barList.xData = [];
      this.barList.yData = [];
      let res = await api.energyRunningTimeTable({
        assetId: this.treeId,
        label: "区域位置",
        subItemId: this.systemList[this.activeSystem].id,
      });
      if (res && res.data.code == 200) {
        this.tableList = Array.from(res.data.data).map((item) => ({
          name: item.entityName,
          day: (item.todayRunTime / 60).toFixed(2),
          month: (item.monthRunTime / 60 / 24).toFixed(2),
          year: (item.yearRunTime / 60 / 24).toFixed(2),
          total: (item.totalRunTime / 60 / 24).toFixed(2),
        }));
        this.getBarData();
      }
    },
    getBarData() {
      this.barList.xData = [];
      this.barList.yData = [];
      let data = JSON.parse(JSON.stringify(this.tableList));
      data.sort(compare(this.runTimeActive));
      data.map((v) => {
        this.barList.xData.push(v[this.runTimeActive]);
        this.barList.yData.push(v.name);
      });
      function compare(prop) {
        return function (a, b) {
          let value1 = a[prop];
          let value2 = b[prop];
          return value2 - value1;
        };
      }
    },
  },
  created() {
    this.getSystemList();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.runTimeStatisticsWrap {
  .runTimeStaContent {
    @include setPage;
    @include setFlexColumn;
    justify-content: space-between;
    .listWrap {
      width: 100%;
      height: 10%;
    }
    .statisticsWrap {
      width: 100%;
      height: calc(90% - 12px);
      @include setFlexBetween;
      .leftTree {
        width: 20%;
        height: 100%;
      }
      .rightData {
        width: calc(80% - 12px);
        height: 100%;
        @include setFlexColumn;
        justify-content: space-between;
        .tabABar {
          width: 100%;
          height: $halfWidth;
          @include setFlexBetween;
          .tableBox {
            width: 57%;
            height: 100%;
          }
          .barBox {
            width: calc(43% - 12px);
            height: 100%;
          }
        }
        .lineBox {
          width: 100%;
          height: $halfWidth;
        }
      }
    }
  }
}
</style>
